 document.addEventListener('DOMContentLoaded', function () {
    const copyButtons = document.querySelectorAll('.discount__copy');

    copyButtons.forEach(button => {
      button.addEventListener('click', function () {
        const codeSpan = this.previousElementSibling; // .discount__code
        const couponCode = codeSpan.textContent.trim();
        const originalText = this.textContent;

        // Copy to clipboard
        navigator.clipboard.writeText(couponCode)
          .then(() => {
            this.textContent = 'COPIED!';
            this.classList.add('copied'); // Optional: for styling

            setTimeout(() => {
              this.textContent = originalText;
              this.classList.remove('copied');
            }, 2000);
          })
          .catch(err => {
            console.error('Failed to copy coupon code: ', err);
          });
      });
    });
  });



document.addEventListener('DOMContentLoaded', () => {
  const input = document.querySelector('#pincode-input');
  const button = document.querySelector('.pincode-submit-button');
  const result = document.querySelector('.pincode-result');
  const icon = document.querySelector('.delivery-icon'); // grab the icon

  button.addEventListener('click', async () => {
    const pincode = input.value.trim();

    // Show icon as soon as user clicks check
    if (icon) icon.style.display = 'inline-block';

    // Validate pincode
    if (!/^\d{6}$/.test(pincode)) {
      result.textContent = 'Invalid pincode';
      result.style.color = 'red';
      return;
    }

    // Loading state
    result.textContent = 'Checking...';
    result.style.color = 'gray';
    button.disabled = true;

    try {
      const response = await fetch('https://script.google.com/macros/s/AKfycbz0b09xBzXI7RU7bcbfky8k4tN4rp3GdMC3pJniA1s6HiME38IIDQ8mGcuC4nDemjJNBQ/exec');
      const data = await response.json();

      const match = data.find(item => String(item.drop_pincode) === pincode);

      if (!match) {
        result.textContent = 'Pincode not serviceable.';
        result.style.color = 'red';
      } else {
        const tatDays = parseInt(match.TAT, 10) || 0;
        const estimatedDate = new Date();
        estimatedDate.setDate(estimatedDate.getDate() + tatDays);

        const formattedDate = estimatedDate.toLocaleDateString(undefined, {
          weekday: 'long',
          year: 'numeric',
          month: 'short',
          day: 'numeric'
        });

        const message = match['Message construct']?.replace('[date]', formattedDate) || '';
        result.innerHTML = message;
      }
    } catch (error) {
      console.error(error);
      result.textContent = 'Error checking pincode. Try again later.';
      result.style.color = 'red';
    }

    // Reset button
    button.disabled = false;
    button.textContent = 'CHECK';
  });
});

//   sticky add to cart offset effect
 
document.addEventListener("DOMContentLoaded", function() {
  const atcWrapper = document.getElementById('sticky-atc-wrapper');

  if (!atcWrapper) return;

  const originalOffset = atcWrapper.offsetTop;
  const bottomOffset = originalOffset + atcWrapper.offsetHeight;

  window.addEventListener('scroll', function() {
    const scrollY = window.scrollY;
    const viewportHeight = window.innerHeight;

    const isAbove = scrollY + viewportHeight < originalOffset;
    const isBelow = scrollY > bottomOffset;

    if (isAbove || isBelow) {
      atcWrapper.classList.add('sticky');
    } else {
      atcWrapper.classList.remove('sticky');
    }
  });

  window.dispatchEvent(new Event('scroll'));
});
